import { useEffect, useState } from 'react';
// import { Button } from '@mui/material';
import bcrypt from 'bcryptjs-react';
import { setCookie, getCookie } from '../../../common/utils';

const generateClientId = () => `${Date.now()}-${Math.floor(Math.random() * 1000)}`;

const Poll = ({ item, CONSTANTS, formatDate }: any) => {
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [hasVoted, setHasVoted] = useState(false);
  const [initialVoteLoaded, setInitialVoteLoaded] = useState(false);

  useEffect(() => {
    const storedOption = getCookie(`poll-${item.msid}`);
    if (storedOption) {
      setSelectedOption(parseInt(storedOption, 10));
      setInitialVoteLoaded(true);
    }
  }, [item.msid]); 

  const handleSubmit = async (currentSelection: number | null) => {
    if (!currentSelection || hasVoted || initialVoteLoaded) return;

    const url = `${CONSTANTS.CDS_API}/cds-feed-ext/submit/poll/m360`;

    const rawPayload = JSON.stringify({
      hostid: parseInt(item?.hostid),
      clientId: generateClientId(),
      date: Date.now().toString(),
      location: "DemoLocation",
      msid: parseInt(item?.msid),
      username: "DemoUser", // Consider if this needs to be dynamic or removed if not used
      voteoptionno: currentSelection,
    });

    const hashedHeaderString = bcrypt.hashSync(rawPayload, 6);
    const headers = {
      'Content-Type': 'application/json',
      'p-nonce': hashedHeaderString,
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: rawPayload
      });

      if (response.ok) {
        // Persist vote
        setCookie(`poll-${item.msid}`, String(currentSelection), 7); // expires in 7 days
        setHasVoted(true);
        console.log("Vote submitted successfully.");
      } else {
        console.error('Poll submit error:', response.statusText);
      }
    } catch (error) {
      console.error('Poll submit error:', error);
    }
  };

  return (
    <div className='poll-container' id={`poll-${item.msid}`}>
      <div className='time'>{formatDate(item.insertdate)}</div>
      <div className='blogBlockHeading'>Poll: {item.title}</div>

      <div className='blogBlockContentWrapper'>
        {item.polloptions.map((option: any) => (
          <div key={option.optionno} className='inputPollWrapper'>
            <input
              type="radio"
              id={`option-${option.optionno}`}
              name={`poll-${item.msid}`}
              value={option.optionno}
              checked={selectedOption === option.optionno}
              disabled={hasVoted || initialVoteLoaded}
              onChange={() => {
                setSelectedOption(option.optionno); // Keep this for UI update
                handleSubmit(option.optionno);     // Pass the current option directly
              }}
              style={{ marginRight: '10px' }}
            />
            <label htmlFor={`option-${option.optionno}`}>{option.description}</label>
          </div>
        ))}
      </div>

      {hasVoted && selectedOption && ( // Show "submitted" only if an option was selected in this session or loaded from cookie
        <div className='pollSubmitted'>
          Your poll is submitted!
        </div>
      )}
      {initialVoteLoaded && selectedOption && ( // Specifically for when loaded from cookie without a current session selection
        <div className='pollSubmitted'>
          You have already submitted this poll
        </div>
      )}

      {/* <Button
        variant="contained"
        size="small"
        disabled={hasVoted || selectedOption === null}
        sx={{
          mt: 2,
          backgroundColor: '#ff7700',
          '&:hover': { backgroundColor: '#e66d00' }
        }}
        onClick={handleSubmit}
      >
        {hasVoted ? 'Voted' : 'Vote'}
      </Button> */}
    </div>
  );
};

export default Poll;
